module.exports = __webpack_public_path__ + "static/programs-64accc2c02a4f23ff5eaf1f46d7ba511.png";